import { jsPDF } from 'jspdf';
import { clean, safeName, download } from './exporters';
import { APP_INFO, fill } from './license';
import { BRANCH_KEYS, SUB_KEYS } from './policy';

// KRITIS audit sheet: current company policy as confirmed by the server, with signature fields
export function kritisPdf(t, d) {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  const M = 16, W = 178, dt = (v) => (v ? new Date(v).toLocaleString(t.locale) : '-');
  const p = d.policy || {}, on = !!p.kritis;
  let y = 0;
  doc.setFillColor(15, 23, 42); doc.rect(0, 0, 210, 26, 'F');
  doc.setTextColor(255); doc.setFont('helvetica', 'bold'); doc.setFontSize(15); doc.text(clean(t.knTitle), M, 12);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.text(clean(`${APP_INFO.name} · ${t.knChecked}: ${dt(d.checked_at)}`), M, 20);
  y = 36;
  const kv = (k, v) => { doc.setTextColor(90); doc.setFont('helvetica', 'normal'); doc.setFontSize(9.5); doc.text(clean(k), M, y); doc.setTextColor(20); doc.setFont('helvetica', 'bold'); doc.text(clean(String(v ?? '-')), M + 58, y, { maxWidth: W - 58 }); y += 6.2; };
  const head = (s) => { y += 3; doc.setFont('helvetica', 'bold'); doc.setFontSize(11.5); doc.setTextColor(15, 23, 42); doc.text(clean(s), M, y); doc.setDrawColor(203, 213, 225); doc.line(M, y + 1.5, M + W, y + 1.5); y += 8; };
  const para = (s, size = 9.5) => { doc.setFont('helvetica', 'normal'); doc.setFontSize(size); doc.setTextColor(30); const l = doc.splitTextToSize(clean(s), W); doc.text(l, M, y); y += l.length * (size * 0.45) + 2; };
  head(t.knCompany);
  kv(t.knFirm, d.company); kv(t.knCode, d.code); kv(t.knSeats, `${d.devices} / ${d.seats}`); kv(t.knUntil, d.until ? `${d.until.slice(6, 8)}.${d.until.slice(4, 6)}.${d.until.slice(0, 4)}` : '-');
  kv(t.knChanged, `${dt(d.changed_at)}${d.changed_by ? ` · ${d.changed_by}` : ''}`); kv(t.knDevice, d.device);
  head(t.knStatus);
  doc.setFillColor(...(on ? [22, 163, 74] : [220, 38, 38])); doc.roundedRect(M, y - 5, 70, 8, 2, 2, 'F');
  doc.setTextColor(255); doc.setFont('helvetica', 'bold'); doc.setFontSize(11); doc.text(clean(on ? t.knOn : t.knOff), M + 4, y + 0.5); y += 10;
  [t.knB1, t.knB2, t.knB3, t.knB4].forEach((s) => para(`${on ? '[X]' : '[ ]'} ${s}`));
  head(t.knBranches);
  para(`${t.knVisible}: ${BRANCH_KEYS.filter((k) => !(p.branches || []).includes(k)).map((k) => t['pf_' + k]).join(', ')}`);
  para(`${t.knHidden}: ${hiddenNames(t, p) || '-'}`);
  if ((d.log || []).length) para(fill(t.klSee, { n: d.log.length }), 9);
  head(t.knData);
  [t.knD1, t.knD2, t.knD3, t.knD4].forEach((s) => para(`- ${s}`));
  head(on ? t.knExtAllowed : t.knExt);
  if (!on) para(t.knExtTxt, 9);
  else {
    const al = (p.allow || []).map((k) => t['omExt_' + k]);
    para(al.length ? al.join(', ') : t.knExtNone, 9);
    if (p.map?.url) para(`${t.knOwnMap}: ${p.map.name ? `${p.map.name} – ` : ''}${p.map.url}${p.map.type === 'wms' ? ` (WMS ${p.map.layers})` : ''}`, 9);
    if (p.cache !== false) para(t.knCacheNote, 9);
    else para(t.knNoCache, 9);
  }
  y = Math.max(y + 18, 258);
  doc.setDrawColor(100, 116, 139); doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor(60);
  [[M, t.knSigPlace], [M + 62, t.knSigAdmin], [M + 124, t.knSigDpo]].forEach(([x, s]) => { doc.line(x, y, x + 54, y); doc.text(clean(s), x, y + 4); });
  doc.setFontSize(7); doc.setTextColor(120); doc.text(clean(`${APP_INFO.name} · ${t.knFoot}`), M, 288);
  if ((d.log || []).length) logPages(doc, t, d, M);
  download(doc.output('blob'), `${safeName(`KRITIS-Nachweis ${d.company || ''}`)}.pdf`, true);
}

export const hiddenNames = (t, e) => [...(e.branches || []).map((k) => t['pf_' + k]), ...(e.subs || []).filter((s) => SUB_KEYS.includes(s) && !(e.branches || []).includes('detect')).map((s) => `${t.pf_detect} – ${t['dsub_' + s]}`)].join(', ');
export const logAction = (t, a) => t['klA_' + String(a).replace('+', '_')] || a;

// page 2+: change protocol, newest first
function logPages(doc, t, d, M) {
  const cols = [[M, t.klWhen], [M + 34, t.klAction], [M + 76, t.klDevice], [M + 110, t.klState], [M + 134, t.knHidden]];
  let y = 0;
  const page = () => {
    doc.addPage(); doc.setFont('helvetica', 'bold'); doc.setFontSize(13); doc.setTextColor(15, 23, 42);
    doc.text(clean(`${t.klTitle} – ${d.company || ''}`), M, 16);
    doc.setFontSize(8.5); doc.setFillColor(241, 245, 249); doc.rect(M, 22, 178, 7, 'F');
    cols.forEach(([x, s]) => doc.text(clean(s), x + 1, 27)); y = 35;
  };
  page();
  d.log.forEach((e) => {
    const hid = e.action === 'reset' ? '' : hiddenNames(t, e) || '-', lines = doc.splitTextToSize(clean(hid), 43), act = doc.splitTextToSize(clean(logAction(t, e.action)), 40), n = Math.max(lines.length, act.length, 1);
    if (y + n * 3.6 > 280) page();
    doc.setFont('helvetica', 'normal'); doc.setFontSize(8.5); doc.setTextColor(30);
    doc.text(clean(new Date(e.at).toLocaleString(t.locale)), M + 1, y);
    doc.text(act, M + 35, y);
    doc.text(clean(e.device === 'owner' ? t.klOwner : e.device || '-'), M + 77, y);
    doc.text(clean(e.action === 'reset' ? '-' : e.kritis ? t.knOn : t.knOff), M + 111, y);
    doc.text(lines, M + 135, y);
    y += n * 3.6 + 2.4;
    doc.setDrawColor(226, 232, 240); doc.line(M, y - 3.5, M + 178, y - 3.5);
  });
}
